<template lang="pug">
  div.wrap-item-share-buttons
    a(:href="twitterURL"
      :data-url="url"
      data-lang="ja"
      target="_about").f.fm.mb8.px12.py4
      v-icon.mr4 mdi-twitter
      span.btn-label.fz14.pt2 Share with Twitter
    a(:href="`http://www.facebook.com/share.php?u=${url}`"
      rel="nofollow"
      target="_blank").f.fm.mb8.px12.py4
      v-icon.mr4 mdi-facebook
      span.btn-label.fz14.pt2 Share with Facebook
    a(v-clipboard:copy="url" v-clipboard:success="onCopyLink").f.fm.px12.py4
      v-icon.mr4 mdi-link-variant
      span.btn-label.fz14.pt2 Copy invitation URL
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-share-buttons {
  a {
    border: $basic_border;
    border-radius: 9px;
    .btn-label {
      color: $primary_text_color;
    }
  }
}
</style>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    hashtags: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  computed: {
    twitterURL () {
      return (this.hashtags) ? `//twitter.com/share?hashtags=${this.hashtags}&url=${this.url}` : `//twitter.com/share?url=${this.url}`
    }
  },
  methods: {
    onCopyLink () {
      alert("リンクをコピーしました。")
    }
  }
}
</script>